import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timer-container"
}
const _hoisted_2 = {
  class: "timer-svg",
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = { class: "timer-group" }
const _hoisted_4 = ["stroke-dasharray"]
const _hoisted_5 = { class: "timer-label" }

import { onMounted, ref } from "vue";

const WARNING_THRESHOLD = 10;
const ALERT_THRESHOLD = 5;


export default /*@__PURE__*/_defineComponent({
  __name: 'CountdownTimer',
  props: {
    time: {}
  },
  setup(__props: any) {

const props = __props;

let TOTAL_TIME = 0;
if (props.time) {
  TOTAL_TIME = +props.time;
}

const COLOR_CODES = {
  info: {
    color: "green",
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD,
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD,
  },
  neutral: {
    color: "grey",
  },
};

const remainingPathColor = ref(COLOR_CODES.info.color);
const dashStroke = ref("283 283");

const timeLeft = ref(0);
timeLeft.value = TOTAL_TIME;

function formatTime() {
  const time = timeLeft.value;
  const minutes = Math.floor(timeLeft.value / 60);

  const seconds = time % 60;

  if (seconds < 10) {
    return `${minutes}:0${seconds}`;
  }

  return `${minutes}:${seconds}`;
}

function startTimer() {
  let timePassed = 0;
  const interval: number = setInterval(() => {
    timePassed += 1;
    timeLeft.value = TOTAL_TIME - timePassed;
    setCircleDasharray(timeLeft.value);
    setRemainingPathColor(timeLeft.value);
    if (timeLeft.value === 0) {
      clearInterval(interval);
    }
  }, 1000);
}

onMounted(() => {
  startTimer();
});

function calculateTimeFraction(timeLeft: number) {
  const rawTimeFraction = timeLeft / TOTAL_TIME;
  return rawTimeFraction - (1 / TOTAL_TIME) * (1 - rawTimeFraction);
}

// Update the dasharray value as time passes, starting with 283
function setCircleDasharray(timeLeft: number) {
  const gapDashStroke = (calculateTimeFraction(timeLeft) * 283).toFixed(0);
  if (+gapDashStroke <= 0) {
    dashStroke.value = `0 283`;
  } else {
    dashStroke.value = `${gapDashStroke} 283`;
  }
}

function setRemainingPathColor(timeLeft: number) {
  const { alert, warning, neutral } = COLOR_CODES;

  if (timeLeft <= 0) {
    remainingPathColor.value = neutral.color;
  } else if (timeLeft <= alert.threshold) {
    remainingPathColor.value = alert.color;
  } else if (timeLeft <= warning.threshold) {
    remainingPathColor.value = warning.color;
  }
}

return (_ctx: any,_cache: any) => {
  return (_ctx.time)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("g", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("circle", {
              class: "timer-circle",
              cx: "50",
              cy: "50",
              r: "45"
            }, null, -1)),
            _createElementVNode("path", {
              "stroke-dasharray": dashStroke.value,
              class: _normalizeClass(["timer-circle-remaining", remainingPathColor.value]),
              d: "\n          M 50, 50\n          m -45, 0\n          a 45,45 0 1,0 90,0\n          a 45,45 0 1,0 -90,0\n        "
            }, null, 10, _hoisted_4)
          ])
        ])),
        _createElementVNode("span", _hoisted_5, _toDisplayString(formatTime()), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})